// Matches [name] in ApplicantType table
const APPLICANT_TYPES = {
  CORPORATE_UNIT_LEASE_SIGNER: 'Corporate Unit Lease Signer',
  COURTESY_OFFICER_LEASE_SIGNER: 'Courtesy Officer Lease Signer',
  EMPLOYEE_LEASE_SIGNER: 'Employee Lease Signer',
  FINANCIAL_LEASE_SIGNER: 'Financial Lease Signer',
  GUARANTOR_LEASE_SIGNER: 'Guarantor Lease Signer',
  LIVE_IN_CARETAKER: 'Live-In-Caretaker',
  MINOR: 'Minor',
  NON_FINANCIAL_LEASE_SIGNER: 'Non-Financial Lease Signer',
  PET: 'Pet',
  VENDOR_UNIT_LEASE_SIGNER: 'Vendor Unit Lease Signer',
};

export default APPLICANT_TYPES;
